import { Service } from '@timing71/common';

import { Client } from "./client.js";
import { SocketIOClient } from '../socketio.js';


export class Cronococa extends Service {

  start(connectionService) {
    super.start(connectionService);

    this._socketIO = new SocketIOClient(
      'www.cronococa.com:843',
      connectionService
    );

    this._client = new Client(this._socketIO, this.onStateChange, this.onManifestChange);
  }

  stop() {
    this._socketIO?.stop();
  }

}

Cronococa.regex = /online.cronococa.com/;
